'use es6';

import { Fragment } from 'react';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useTestVariationDropdownButtonProps = ({
  pageName
}) => {
  const buttonClassName = 'p-all-2 m-left-1';
  const buttonUse = 'tertiary-light';
  const buttonText = /*#__PURE__*/_jsx(UITruncateString, {
    maxWidth: 250,
    children: /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "p-right-1",
        name: "test"
      }), pageName]
    })
  });
  return {
    buttonClassName,
    buttonText,
    buttonUse
  };
};